<template>
  <div>
    <refund-details
      v-if="getterPopupName === 'RefundDetails'"
      :txnDetails="popupDetails"
      @refreshList="refreshDetails"
      :title="'Refund Details'"
      :btnOptions="refundOptions"
    />
    <refund-filter
      v-else-if="getterPopupName === 'RefundFilter'"
      @updateFilters="updateFilters"
    />
    <refund-export
      v-else-if="getterPopupName === 'RefundExport'"
      :exportOptions="paginate"
      :exportRecords="exportRecords"
    />

    <div class="table-title">
      <div class="subject">
        <p>Refunds</p>
        <span v-if="typeof paginate.total === 'number'">
          Total ({{paginate.total}})
        </span>

        <refund-webhooks v-if="paginate.total && webhooksAllowed"
          :paginate="paginate"
          @resendWebhooks="bulkResendWebhooks"
        />
      </div>

      <div class="filters">
        <div class="options">
          <button @click="openPopup('RefundExport')">
            Export
            <i class="fa fa-share" />
          </button>
          <button @click="openPopup('RefundFilter')"
            :class="{'filters-applied': filtersApplied}"
            class="dark-btn"
          >
            Filter
            <i class="fa fa-filter" />
          </button>
        </div>
      </div>
    </div>

    <div class="table-head" v-if="isDesktop()">
      <p class="d-xl">ID</p>
      <p>Amount</p>
      <p>Created Time</p>
      <p>Ref ID</p>
      <p>Order Ref ID</p>
      <p>Status</p>
    </div>

    <div class="table-body">
      <div
        v-for="(data, index) in list" :key="index"
        class="table-row cursor mt-align-self"
        @click="showDetails(data)"
      >
        <p class="d-xl">
          <span>{{data.id}}</span>
        </p>
        <p>
          <b v-if="!isDesktop()">Order amt:</b>
          {{amountFormat(data.amount)}}
        </p>
        <p class="mt-grey-text">
          <b v-if="!isDesktop()">Created:</b>
          {{data.created_at}}
        </p>
        <p>
          <b v-if="!isDesktop()">Ref ID:</b>
          <span>{{data.reference_id}}</span>
        </p>
        <p>
          <b v-if="!isDesktop()">Order ref ID:</b>
          <span>{{data.order_reference_id}}</span>
        </p>
        <p class="mt-grey-text">
          {{data.status}}
          <i v-if="data.status === 'PENDING'"
            class="fa fa-sync-alt"
            @click="refreshDetails($event, data)"
          />
        </p>
      </div>
    </div>

    <table-loader v-if="!paginate.data_added || !paginate.stop" />

    <div class="table-empty" v-else-if="paginate.total === 0">
      <p>{{emptyRecords}}</p>
    </div>
  </div>
</template>

<script>
import RefundDetails from '@/components/AccountStatement/StatementDetails'
import RefundFilter from '@/components/PG/Refunds/Filters'
import RefundExport from '@/components/global/ExportConfirmation'
import RefundWebhooks from '@/components/global/BulkResendWebhooks'

import ApiServices from '@/services/api/pgRefunds'
import listMixins from '@/mixins/listMixins'
import { amountFormat } from '@/utils/helpers'

export default {
  name: 'PgRefunds',
  components: { RefundDetails, RefundWebhooks, RefundFilter, RefundExport },
  mixins: [listMixins],
  data () {
    return {
      refundOptions: [],
      resendWebhookOption: {
        text: 'Resend Webhook',
        css: 'primary-btn',
        icon: 'fa-paper-plane',
        action: () => {
          this.resendWebhook()
        }
      }
    }
  },
  watch: {
    getterPopupName (newVal) {
      if (newVal === this.keys.popup) {
        this.refundOptions = []

        if (this.popupDetails.webhook_allowed) {
          this.refundOptions.push(this.resendWebhookOption)
        }
      }
    }
  },
  created () {
    this.startProcessing()
  },
  methods: {
    amountFormat,
    populateParams () {
      this.api['bulkResendWebhook'] = ApiServices.bulkResendWebhook
      this.api['export'] = ApiServices.export
      this.api['fetchStatus'] = ApiServices.fetchStatus
      this.api['resendWebhook'] = ApiServices.resendWebhook
      this.api['count'] = ApiServices.count
      this.keys['popup'] = 'RefundDetails'
      this.keys['list'] = 'refunds'
      this.paginate['type'] = 'refund'
      this.paginate['token_type'] = 'next_page_token'
    },
    fetchRecords (start) {
      return new Promise(resolve => {
        let params = {...this.filterOptions}
        if (start) {
          params['next_page_token'] = this.paginate['next_page_token']
        }

        ApiServices.list(params).then(response => {
          this.SET_STATEMENT_FILTER(this.filterOptions)
          if (response.reason === 'UNPRIVILEGED') {
            return
          }

          let data = response.data
          if (start) {
            this.list.push(...data.refunds)
            if (data.next_page_token) {
              this.paginate['next_page_token'] = data['next_page_token']
            } else {
              this.paginate['stop'] = true
            }
            resolve()
          } else {
            this.list = data.refunds
            this.setPaginate(data)
            this.populateMeta(response)

            if (data['next_page_token']) {
              this.getListCount(resolve)
            } else {
              resolve()
            }
          }
        })
      })
    },
    populateMeta ({data}) {
      this.webhooksAllowed = data.webhook_allowed
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/table.scss';
</style>
